
export default {
  data() {
    return {
      forms: [],
      formId: 0,
      formData: null,
      pageData: null,
      selectedFiles: [],
      successMsgShown: false,
    };
  },
  watch: {
    $isInEditMode(v) {
      this.getAllForms();
    },
  },
  mounted() {
    this.getPageData();

    if (this.$isInEditMode) {
      this.getAllForms();
    }
  },
  methods: {
    getPageData() {
      if (
        this.$parent &&
        this.$parent.$parent &&
        this.$parent.$parent.pageData
      ) {
        this.pageData = this.$parent.$parent.pageData;

        if (
          this.pageData &&
          this.pageData.components &&
          this.pageData.components.length
        ) {
          this.pageData.components.forEach((data) => {
            if (data && data.linkMeta && data.linkMeta.formId) {
              this.formId = parseInt(
                data.linkMeta.formId.replace(/(<([^>]+)>)/gi, "")
              );
              this.getForm();
            }
          });
        }
      }
    },

    async getAllForms() {
      const body = {
        customConfig: {},
        filters: [],
        limit: 100,
        list: true,
        offset: 0,
        page: 1,
      };
      try {
        const data = await this.$axios.post(
          "/api/v1/cms/form/filter?gBoxList=true",
          body
        );
        if (data) {
          this.forms = data.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },

    async getForm() {
      try {
        const data = await this.$axios.get(
          "/api/v1/cms/form/get/" + this.formId
        );
        if (data && data.data && data.data.data) {
          this.formData = data.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },

    setFormInputs(form, field, options, currentOption) {
      if (!form) return;

      if (this.formData[field.key]) {
        if (field.type !== "file" && field.type !== "multipleMedia") {
          form[field.key] = this.formData[field.key];
        }
      } else {
        form[field.key] = null;
      }
    },

    returnAllowedExts(file) {
      if (!file) return;

      let allowedExts;
      let index;

      if (file.validation && file.validation.length) {
        allowedExts = file.validation.filter((val) =>
          val.includes("allowedExts")
        );

        if (
          allowedExts &&
          allowedExts.length &&
          allowedExts[0] &&
          typeof allowedExts[0] === "string"
        ) {
          allowedExts = allowedExts[0].replace("allowedExts:", "");

          allowedExts = allowedExts.replace("[", "");
          allowedExts = allowedExts.replace("]", "");
          allowedExts = allowedExts
            .split(" ")
            .map((s) => "." + s)
            .join(" ");
        } else allowedExts = "";
      }

      return allowedExts;
    },

    setFiles(form, field, event) {
      this.selectedFiles = [];

      if (event && event.length) {
        event.forEach((e) => {
          if (this.validateFilesSize(e)) {
            this.selectedFiles.push(e);
          }
        });

        form[field.key] = event;
      } else {
        form[field.key] = null;
      }
    },

    fileUpload(event, form, field) {
      this.selectedFiles = [];
      form[field.key] = null;

      if (!event.target.files) return;
      const files = Array.from(event.target.files);

      if (files && files.length && this.validateFilesSize(files, form, field)) {
        files.forEach((file) => {
          this.selectedFiles.push({ originalName: file.name });
        });
      }
    },

    validateFilesSize(files) {
      if (!files) return;

      var filesSize = 0;

      if (files && files.length) {
        files.forEach((file) => {
          filesSize += file.size;
        });
      }

      if (filesSize / 1024 ** 2 > 10) {
        this.$toast.error(this.$t("toast.fileTooBig"));
        form[field.key] = null;
        return false;
      } else return true;
    },

    deleteFile(file, form, field) {
      if (!file) return;

      if (form[field.key] && typeof form[field.key] !== "string") {
        form[field.key] = form[field.key].filter(function (item) {
          return item !== file.media;
        });
      }

      this.selectedFiles = this.selectedFiles.filter(function (item) {
        return item !== file;
      });

      if (this.selectedFiles && !this.selectedFiles.length) {
        form[field.key] = null;
      }
    },

    showSuccessMsg() {
      this.successMsgShown = true;

      setTimeout(() => {
        const element = document.getElementById("success-custom-form-msg");
        if (element) {
          element.scrollIntoView();
        } else this.$scrollToTop();
      }, 50);
    },
  },
};
